
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var timer = document.querySelector('[class*="countdown_timer_wrapper_"]');
    var target = document.querySelector('.product-form');
    
    if (timer && target) {
      target.parentNode.insertBefore(timer, target);
    }
  }, 1500);
});
